export const serverToServerCommunicationOptions = [
  { label: "SFTP", value: "sftp" },
  { label: "FTPS", value: "ftps" },
  { label: "Other", value: "other" },
  { label: "N/A", value: "na" },
];

export const i2cServerOptionSelect = [
  { label: "Yes (VPN Required)", value: "yes" },
  { label: "No", value: "no" },
  { label: "Other", value: "other" },
];
export const vpnSetupOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "N/A", value: "na" },
];

export const secureVPNOptions = [
  { label: "Web Services Pull API", value: "web_services_pull_api" },
  { label: "File Exchange", value: "file_exchange" },
  { label: "Coop Authorization", value: "coop_authorization" },
  { label: "Other", value: "other" },
];